import { jsonFetch } from "@/lib/helpers";
import { AvantioAccommodation } from "../../../models/integrations/avantio.models";
import { getAvantioAccommodationsUrl } from "./api-url.constants";
import { AvantioAccommodationsApiDTO } from "./dtos";
import { mapAvantioAccommodationsDTOToAvantioAccommodations } from "./mappers";

export const getAvantioAccommodations = async (
  userId?: string
): Promise<AvantioAccommodation[]> => {
  const response = await jsonFetch<AvantioAccommodationsApiDTO>(
    getAvantioAccommodationsUrl(userId)
  );
  return mapAvantioAccommodationsDTOToAvantioAccommodations(response.data);
};
